import { useForm as createUseForm } from "@ant-design-vue/use";
import { Tooltip, Button, notification } from "ant-design-vue";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import i18n from "../../../../i18n";
import { modalStyleForm } from "../../../../utils/constant";
import { initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { validateError, required, requiredWhen, thPidFirstCharacter, thPid } from "../../../../utils/validate";
import { callTitle } from "../../../app/setting/user-mgt/user/user.section";
import { createConditionForm } from "./user-modal.condition";
import store from "../../../../store";
import { callGender, callNationality, callRace, callCompanyType } from "../../register/register.section";

import {
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
} from "../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading();

export const UserModalForm = defineAsyncComponent(() => import("./UserModalForm"));
const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));
export const callCheckIdTax = ({ idTax }) => store.dispatch("resource/v1/security/user/checkIdTax", { idTax });
export const callCheckIdCardSystem = ({ form }) => store.dispatch("resource/v1/security/user/checkIdCardSystem", { data: form });

export const openModalForm = ({ props, onOk, bind, itemsArr }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.request.register.company"),
                width: "80%",
                onOk: () => {
                    refs.form.callOnClickModalOk().then((record) => {
                        onOk?.(record);
                        if (itemsArr) {
                            itemsArr.push(record);
                        } else {
                            lodash.merge(props.form, record);
                        }
                        options.bind.onCancel();
                    });
                },
            },
            bind
        ),
        render: () => (
            <UserModalForm
                ref={(e) => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></UserModalForm>
        ),
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        idCard: null,
        refTitle: null,
        firstNameTh: null,
        lastNameTh: null,
        refGender: null,
        refRace: null,
        refNationality: null,
    };
};

export const createRules = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return {
        ["idCard"]: [required,  requiredWhen({
            when: () => model.refPersonType?.key != "1",
            requiredValidator: ({ rule, value }) => {
                return thPid.validator(rule, value);
            },
        }),
        requiredWhen({
            when: () => model.refPersonType?.key != "1",
            requiredValidator: ({ rule, value }) => {
                return thPidFirstCharacter.validator(rule, value);
            },
        }),],
        ["refNationality"]: [required],
        ["refRace"]: [required],
        ["refGender"]: [required],
        ["refTitle"]: [required],
        ["firstNameTh"]: [required],
        ["lastNameTh"]: [required],
    };
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}idCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => (["1"].includes(model.refPersonType?.key) ? i18n.global.t("views.register.idTax") : i18n.global.t("model.user.idCard")),
                labelRender: () => (
                    <span>
                        {iconCheckIdCard({ data, model })}{" "}
                        {["1"].includes(model.refPersonType?.key) ? i18n.global.t("views.register.idTax") : i18n.global.t("model.user.idCard")}
                    </span>
                ),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.idCard,
                            "onUpdate:value": (value) => {
                                model.idCard = value;
                                model.username = value;
                            },
                            disabled: viewOnly,
                            comma: false,
                            onBlur: () => useForm.validate(field.key).catch(() => {}),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
            }),
            {
                visible: () => ["waitApprove"].includes(model.refStatus?.key) && viewOnly,
                key: `${prefix}buttonLinkUser`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => (
                    <Button
                        class="btn btn-primary"
                        style="float:right"
                        onClick={() => {
                            setIsLoadingApp(true);
                            let promise = Promise.resolve(null);
                            if (["1"].includes(model.refPersonType?.key)) {
                                promise = callCheckIdTax({ idTax: model.idCard })
                                    .then((res) => {
                                        setIsLoadingApp(false);
                                        if (!res) {
                                            data.linkIdCard = "wait";
                                            notification["error"]({ message: i18n.global.t("views.register.idTaxCheckNotFound") });
                                            return null;
                                        }
                                        const resultList = res?.ResultList?.[0];
                                        return {
                                            idCard: resultList.JuristicID,
                                            companyNameTh: resultList.JuristicName_TH,
                                            companyType: resultList.JuristicType,
                                            registerCapital: resultList.RegisterCapital,
                                            registerDate: resultList.RegisterDate,
                                        };
                                    })
                                    .catch(() => {
                                        data.linkIdCard = "wait";
                                    });
                               
                            } else {
                                promise = callCheckIdCardSystem({ form: model })
                                    .then((res) => {
                                        setIsLoadingApp(false);
                                        if (!res) return null;
                                        return {
                                            firstNameTh: res.firstNameTh,
                                            idCard: res.idCard,
                                            lastNameTh: res.lastNameTh,
                                            birthDate: res.birthDate,
                                            title: res.title,
                                            expireDate: res.expireDate,
                                        };
                                    })
                                    .catch(() => {
                                        data.linkIdCard = "wait";
                                    });
                            }
                            promise.then((d) => {
                                setIsLoadingApp(false);
                                data.linkIdCard = d;
                                if (!d) {
                                    data.linkIdCard = "wait";
                                }
                            });
                        }}
                    >
                        {i18n.global.t("model.register.linkUser")}
                    </Button>
                ),
            },
            {
                key: `${prefix}spaceIdCard`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCompanyType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refCompanyType"),
                labelRender: () => (
                    <span>
                        {iconCheckCompanyType({ data, model })} {i18n.global.t("model.user.refCompanyType")}
                    </span>
                ),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCompanyType,
                            "onUpdate:value": (value) => (model.refCompanyType = value),
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}companyNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.user.companyNameTh"),
                labelRender: () => (
                    <span>
                        {iconCheckCompanyNameTh({ data, model })} {i18n.global.t("model.user.companyNameTh")}
                    </span>
                ),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyNameTh,
                            "onUpdate:value": (value) => (model.companyNameTh = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTitle`,
                colProp: () => ({ xs: 24, md: 7 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
                label: () => `${i18n.global.t("model.user.refTitle")}`,
                labelRender: () => (
                    <span>
                        {iconCheckTitle({ data, model })} {i18n.global.t("model.user.refTitle")}
                    </span>
                ),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refTitle,
                            "onUpdate:value": (value) => (model.refTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}firstNameTh`,
                colProp: () => ({ xs: 24, md: 7 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.user.firstNameTh"),
                labelRender: () => (
                    <span>
                        {iconCheckFirstNameTh({ data, model })} {i18n.global.t("model.user.firstNameTh")}
                    </span>
                ),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.firstNameTh,
                            "onUpdate:value": (value) => (model.firstNameTh = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastNameTh`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.user.lastNameTh"),
                labelRender: () => (
                    <span>
                        {iconCheckLastNameTh({ data, model })} {i18n.global.t("model.user.lastNameTh")}
                    </span>
                ),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastNameTh,
                            "onUpdate:value": (value) => (model.lastNameTh = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refGender`,
                colProp: () => ({ xs: 24, md: 7 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
                label: () => i18n.global.t("model.user.refGender"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refGender,
                            "onUpdate:value": (value) => (model.refGender = value),
                            disabled: viewOnly,
                            list: callGender,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refNationality`,
                colProp: () => ({ xs: 24, md: 7 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.user.refNationality"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refNationality,
                            "onUpdate:value": (value) => (model.refNationality = value),
                            disabled: viewOnly,
                            list: callNationality,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRace`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.user.refRace"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRace,
                            "onUpdate:value": (value) => (model.refRace = value),
                            disabled: viewOnly,
                            list: callRace,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
        ],
    });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then((page) => initUseForm({ data, page }))
        .then(() => loadDefaultForm({ props, data }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const promises = [callGender({})];
    return Promise.all(promises).then((arr) => {
        data.genderTypes = arr[0];

        modelRef.refGender = data.genderTypes.find((d) => d.key === "M");
    });
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs });
};

export const iconCheckIdCard = ({ data, model }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (data.linkIdCard?.idCard !== model.idCard && !data.linkIdCard?.idCard) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <Tooltip title={data.linkIdCard?.idCard}>{icon}</Tooltip>;
};

export const iconCheckCompanyNameTh = ({ data, model }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (
        data.linkIdCard?.companyNameTh?.indexOf(model.companyNameTh) === -1 &&
        model.companyNameTh.indexOf(data.linkIdCard?.companyNameTh) === -1
    ) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <Tooltip title={data.linkIdCard?.companyNameTh}>{icon}</Tooltip>;
};

export const iconCheckCompanyType = ({ data, model }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (
        data.linkIdCard?.companyType?.indexOf(model.refCompanyType?.value) === -1 &&
        model.refCompanyType?.value.indexOf(data.linkIdCard?.companyType) === -1
    ) {
    // } else if (
    //     !(model.refCompanyType?.value.indexOf(data.linkIdCard?.companyType) === -1)
    // ) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <Tooltip title={data.linkIdCard?.companyType}>{icon}</Tooltip>;
};

export const iconCheckTitle = ({ data }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (!data.linkIdCard?.title) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <span>{icon}</span>;
};

export const iconCheckFirstNameTh = ({ data }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (!data.linkIdCard?.firstNameTh) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <span>{icon}</span>;
};

export const iconCheckLastNameTh = ({ data }) => {
    let icon = null;
    if (!data.linkIdCard) {
        return null;
    }
    icon = <CIcon class="text-success" file="check.svg"></CIcon>;
    if ("wait" === data.linkIdCard) {
        icon = <CIcon class="text-danger" file="waiting.svg"></CIcon>;
    } else if (!data.linkIdCard?.lastNameTh) {
        icon = <CIcon class="text-danger" file="close.svg"></CIcon>;
    }
    return <span>{icon}</span>;
};
